// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/build/onprem-release-26-1.202607242334/" + chunkId + ".chunk.js";
};